import { get } from 'lodash'
import React, { Component } from 'react'
import { Query } from 'react-apollo'
import Loader from '../../../common/loader/Loader'
import { fetchProfitCenters } from '../../budgetPlanning/budgetPlanningQueries'
import { ProfitCenter } from '../../budgetPlanning/types'
import { i18n } from '../../index'
import type { Station } from '../../station/stationTypes'
import withActiveStation, { WithActiveStationProps } from '../../station/withActiveStation'
import TotalSalesPage from './TotalSalesPage'

type Props = {} & WithActiveStationProps

@withActiveStation
class TotalSales extends Component<Props> {
  processDropdownContent = (station: Station): Array<Record<string, any>> => {
    const profitCenters = (get(station, 'profitCenters', []) as ProfitCenter[]).filter(
      (profitCenter) => profitCenter.type !== 'Other',
    )
    return [
      {
        ...station,
        name: i18n.t('budgetPlanning.all'),
        type: 'Station',
        profitCenters,
      },
      ...profitCenters,
    ]
  }

  render() {
    const {
      activeStation: { id: stationId },
    } = this.props
    return (
      <div>
        <Query
          query={fetchProfitCenters}
          variables={{
            stationId,
          }}
        >
          {({ loading, error, data }) => (
            <Loader
              {...{
                loading,
                error,
              }}
            >
              <TotalSalesPage
                stationId={stationId}
                options={this.processDropdownContent(get(data, 'station', {}) as Station)}
              />
            </Loader>
          )}
        </Query>
      </div>
    )
  }
}

export default TotalSales
